import PropTypes from 'prop-types';
import React from 'react';

import useProduct from '../../hooks/use_product';
import useTranslation from '../../hooks/use_translation';
import BiomarkerAmount from '../framework/biomarker-amount';
import ProductBrandBadge from '../shop/product_brand_badge';
import SamplingType from './sampling-type';

const ProductBadges = ({ include_types, product_id }) => {
	const { items: products } = useProduct({
		include_products: [product_id],
	});
	const { t } = useTranslation('component_test_product_badges');

	const product = products?.length ? products[0] : null;
	if (!product) return <></>;

	return (
		<>
			{(!include_types || include_types?.includes('markers')) &&
				product.markers?.length > 0 && (
					<span className="me-1 ">
						<BiomarkerAmount
							count={product.markers.length}
							groups={
								product?.default?.group_id
									? [product?.default?.group_id]
									: product.groups
							}
							product_id={product.product_id}
							size="xs"
						/>
					</span>
				)}

			{(!include_types || include_types?.includes('brand')) &&
				product.product_variant.state == 'affiliate' && (
					<span className="me-1">
						<ProductBrandBadge
							product_brand_id={product.product_brand.product_brand_id}
							size="xs"
						/>
					</span>
				)}

			{(!include_types || include_types?.includes('sampling_type')) && (
				<span className="clickable-ignore">
					<SamplingType
						className="list-subtitle d-inline me-1 product-badge text-decoration-none"
						product_id={product_id}
					/>
				</span>
			)}

			{(!include_types || include_types?.includes('self_test')) &&
				product?.type == 'self_test' && (
					<span className="clickable-ignore list-subtitle product-badge text-dark ">
						{t('t1')}
					</span>
				)}
		</>
	);
};

ProductBadges.propTypes = {
	include_types: PropTypes.array,
	product_id: PropTypes.string,
};

export default ProductBadges;
